import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import StudyOverviewView from '../overview/StudyOverviewView';
import StudyOverviewTabState from './StudyOverviewTabState';

export default class StudyOverviewTabView extends Backbone.View<StudyOverviewTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override initialize(): void {
    this.listenTo(this.model, 'change', () => this.render());
  }

  override render(): this {
    const id = this.model.get('studyId');
    const runId = this.model.get('runId');
    renderToDOM(<StudyOverviewView id={id} runId={runId} />, this.el);
    return this;
  }

  override remove(): Backbone.View<StudyOverviewTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

StudyOverviewTabView.initClass();
